/* Auto Generated */

export enum VerticalAlignment {
	top,
	bottom,
}
